import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import SnackbarSuccess from '../../Assets/images/svg/dar_snackbar_success_icon.svg';
import SnackbarWarning from '../../Assets/images/svg/dar_snackbar_warning_icon.svg';
import PropTypes from 'prop-types';
import './snackBar.scss';

const SimpleSnackbar = ({ open, message, severity, handleClose, alertCss }) => {
  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      anchorOrigin={{
        vertical: window.innerWidth < 768 ? 'bottom' : 'top',
        horizontal: window.innerWidth < 768 ? 'center' : 'right',
      }}
      style={{
        marginBottom: window.innerWidth < 768 ? '7vh' : 0,
        marginTop: window.innerWidth >= 768 ? '3.5rem' : 0,
      }}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        variant="filled"
        className={`alertCss ${alertCss} snackbar-alert`}
        iconMapping={{
          success: <img src={SnackbarSuccess} alt="Success" />,
          warning: <img src={SnackbarWarning} alt="Warning" />,
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

SimpleSnackbar.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func,
  message: PropTypes.string.isRequired,
  severity: PropTypes.oneOf(['error', 'warning', 'info', 'success', '']), // Optional prop for severity
  alertCss: PropTypes.string,
};

export default SimpleSnackbar;
